import React from 'react';
import PropTypes from 'prop-types';
import MaterialTextField from 'shared/components/connectedTextField/c/materialTextField/MaterialTextField';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import RemoveIcon from 'material-ui/svg-icons/content/clear';
import AddIcon from 'material-ui/svg-icons/content/add-circle';
import { disabledButtonTextGray, textColorGray } from 'theme/mainColors';
import { LIST_OF_PROFILES } from "shared/constants/PropTypes";

const inputStyle = { width: '100%', marginLeft: 24 };
const textStyle = { fontSize: 15, color: textColorGray };
const selectFieldStyle = { width: '100%', marginTop: 24 };
const iconStyle = { marginTop: 38, marginLeft: 10, cursor: 'pointer' };
const hiddenIconStyle = { marginTop: 38, marginLeft: 10, visibility: 'hidden' };

class ConnectionProfiles extends React.Component {
  constructor(props){
    super(props);
    const { profileId, directoryPath, fileKeyString } = props.sftpProfile;
    this.state = {
      sftpProfile: {
        profileId,
        directoryPath,
        fileKeyString
      }
    };
  }

  handleInputChange = (ev, value) => {
    const target = ev.target;
    this.setState(oldState => ({
      sftpProfile: { ...oldState.sftpProfile, [target.name]: value }
    }), () => {
      this.props.onProfileChange(this.state.sftpProfile);
    });
  }

  handleSelectChange = (ev, index, value) => {
    this.setState(oldState => ({
      sftpProfile: { ...oldState.sftpProfile, profileId: value }
    }), () => {
      this.props.onProfileChange(this.state.sftpProfile);
    });
  }

  handleAddConnectionProfile = () => this.props.onAddConnectionProfile();
  
  handleRemoveConnectionProfile = () => this.props.onRemoveConnectionProfile();

  render() {
    const { profilesList, fetchingProfileList, isRemoveIconDisabled, showAddIcon } = this.props;
    const { sftpProfile } = this.state;
    return (
      <div className="connection-profile-container">
        <div className="connection-profile-container__select-field-column">
          <SelectField
            name={ 'profileId' }
            hintText="Select Import Profile"
            style={ selectFieldStyle }
            maxHeight={ 300 }
            iconStyle={ { fill: disabledButtonTextGray } }
            hintStyle={ { ...textStyle, color: disabledButtonTextGray } }
            labelStyle={ textStyle }
            underlineStyle={ { borderColor: disabledButtonTextGray } }
            value={ sftpProfile.profileId }
            onChange={ this.handleSelectChange }
            disabled= { fetchingProfileList }
          >
            <MenuItem value={ '' } primaryText="Select Import Profile" style={ { color: '#bcbcbc' } } />
            {
              profilesList.map( (profile, index) => (
                <MenuItem key={ index } value={ profile.id } primaryText={ profile.name } />
              ))
            }
          </SelectField>
        </div>
        <div className="connection-profile-container__inputs-column">
          <div className="connection-profile-container__inputs-column__input-container">
            <MaterialTextField
              name={ 'directoryPath' }
              label="Sub-directory path"
              value= { sftpProfile.directoryPath }
              onChange={ this.handleInputChange }
              style={ inputStyle }
              fullWidth={ true }
              required
            />
          </div>
          <div className="connection-profile-container__inputs-column__input-container">
            <MaterialTextField
              name={ 'fileKeyString' }
              label="File Key String (Optional)"
              value= { sftpProfile.fileKeyString }
              onChange={ this.handleInputChange }
              style={ inputStyle }
              fullWidth={ true }
            />
          </div>
        </div>
        <AddIcon color="#00cc00" style={ showAddIcon ? iconStyle : hiddenIconStyle } onClick={ this.handleAddConnectionProfile }/>
        <RemoveIcon style={ isRemoveIconDisabled ? hiddenIconStyle : iconStyle } onClick={ this.handleRemoveConnectionProfile }/>
      </div>
    );
  }
}

ConnectionProfiles.propTypes = {
  profilesList: LIST_OF_PROFILES.isRequired,
  onProfileChange: PropTypes.func.isRequired,
  fetchingProfileList: PropTypes.bool.isRequired,
  onAddConnectionProfile: PropTypes.func.isRequired,
  onRemoveConnectionProfile: PropTypes.func.isRequired,
  isRemoveIconDisabled: PropTypes.bool.isRequired,
  showAddIcon: PropTypes.bool.isRequired,
  sftpProfile: PropTypes.object.isRequired
};

export default ConnectionProfiles;



// WEBPACK FOOTER //
// ./src/components/manageConnection/comp/connectionEditor/c/ConnectionProfiles.js